import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useSaveForm = () => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.SAVE_FORM],
    (data) => ApiService.saveForm(data),
    {
      onSuccess: () => {
        //queryClient.invalidateQueries(QUERY_KEY.GET_GROUP);
        toast.success('Form saved successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useSaveForm